import * as React from "react";
import {connect} from "react-redux";
import {IInformationComponent} from "src/ScrollyInterface";
import {IStateApp} from "../store/StoreInterface";
import ExtraInformation from "./ExtraInformation/ExtraInformation";

const Information = (props: IInformationComponent) => {
	const {
		content,
		ui
	} = props;

	return (
		<div className="Information-container">
			{content.extraInformationIcons ? content.extraInformationIcons.map((informationData: any, i: number) => {
				// Return the element. Also pass key
				return (<ExtraInformation key={`answer${i}`} {...ui} {...informationData} />)
			}) : null}
		</div>
	)
};


const mapStateToProps = (state: IStateApp) => {
	return {
		ui: state.ui
	};
};

export default connect(
	mapStateToProps,
	null
)(Information);
 


// WEBPACK FOOTER //
// ./src/components/InformationComponent.tsx